<template>
    <el-dialog :title="showTitle" :visible.sync="showFlag" :close-on-click-modal="false">
        <el-form
            :inline="true"
            :model="formData"
            class="demo-ruleForm"
            label-width="100px"
            :rules="formRules"
            ref="formData"
            :size="GLOBAL.config.systemSize"
            element-loading-text="数据处理中...请稍等..."
            v-loading="loading">
            <el-form-item label="栏目名称：" prop="tztgUuid" style="margin-top: 20px">
                <el-select v-model="formData.tztgUuid" clearable placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;">
                    <el-option
                    v-for="item in tztgOptions"
                    :key="item.uuid"
                    :label="item.title"
                    :value="item.uuid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标题：" prop="title" style="margin-top: 20px">
                <el-input v-model="formData.title" placeholder="标题" maxlength="64"></el-input>
            </el-form-item>
            <!--区划-->
            <el-form-item label="所属区划：" prop="ssqhdm" style="margin-top: 20px">
              <el-cascader :options="options" :props="setProps" v-model="formData.ssqhdm" change-on-select='ture' :disabled="editFlag"
                           size="mini" ref="myArea" style="width: 100%;"></el-cascader>
            </el-form-item>
            <!--角色-->
            <el-form-item label="角色：" prop="yhlx" style="margin-top: 20px">
              <el-cascader :options="roleOptions" :props="setProps" v-model="formData.yhlx" change-on-select='ture' :disabled="editFlag"
                          size="mini" ref="myAreaRole" style="width: 100%;"></el-cascader>
            </el-form-item>
          <!--是否需签收-->
            <el-form-item label="是否需签收：" prop="sfqs" style="margin-top: 20px">
              <el-select v-model="formData.sfqs" size="mini" style="width: 100%;" :disabled="editFlag">
                <el-option label="无需签收" value="2"></el-option>
                <el-option label="需签收" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内容：" prop="nr" style="margin-top: 20px">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="formData.nr" placeholder="内容" maxlength="1000"></el-input>
            </el-form-item>
        </el-form>
        <el-row class="margin-top-20">
            <el-button @click="closeDialog" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
            <el-button type="primary" @click="saveOrUpdateForm('formData')" style="margin: 0 20px;" :loading="saveLoading"
                        :size="GLOBAL.config.systemSize">保存
            </el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import cascader from '../../components/Cascader'
export default {
    name: 'NoticeDetailDialog',

    components: {
        cascader
    },

    props: {
      refresh: {
        type: Function
      },
    },

    data() {
        return {
            saveLoading: false,
            showTitle: '',
            showFlag: false,
            formData: {
                tztgUuid:'',
                uuid: '',
                ssqhdm: '',
                nr: '',
                title: '',
                yhlx: '',
                sfqs: '0'
            },
            loading: false,
            formRules: {
                tztgUuid: [
                    {required: true, message: '栏目名称不能为空', trigger: 'change'}
                ],
                title: [
                    {required: true, message: '标题不能为空', trigger: 'change'}
                ],
                nr: [
                    {required: true, message: '内容不能为空', trigger: 'change'}
                ],
                // ssqhdm: [
                //     {required: true, message: '请选择管辖区划', trigger: 'change'}
                // ],
                // yhlx: [
                //     {required: true, message: '请选择人员类型', trigger: 'change'}
                // ],
            },
            tztgOptions: [],
            //所属区域
            setProps: {
                multiple: true, // 多选
                checkStrictly: true, // 父节点取消选中关联
                value: 'code',
                label: 'name',
                children: 'children',
                leaf: 'leaf'
            },
            options: localStorage.getItem('noticeDetailsTree')?JSON.parse(localStorage.getItem('noticeDetailsTree')):[],
            roleOptions: localStorage.getItem('noticeRoles')?JSON.parse(localStorage.getItem('noticeRoles')):[],
            editFlag: false
        }
    },

    methods: {
        // 获取所有栏目
        getAllBotice() {
            let _this = this;
            let param = {
                baseService: 'TGcTztgServiceImpl',
                // baseService: _this.GLOBAL.config.baseServiceType.TGcOrganizationServiceImpl,
                // type: 'getTreeTwo',
                type: 'getAll'
            }
            _this.FUNCTIONS.systemFunction.jsonPost(
                _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                param,
                resultData => {
                    if (resultData) {
                        debugger
                        this.tztgOptions = resultData.obj;
                    } else {

                    }
                }
            )
        },
        closeDialog() {
            this.$refs['formData'].resetFields();
            this.showFlag = false;
        },

        open(type, rowData) {
            let _this = this;
            let title = '';
            _this.type = type;
            if (type == 'edit') {
                _this.editFlag = true;
                title = '通知公告详情编辑';
                _this.formData.uuid = rowData.uuid;
                _this.formData.nr = rowData.nr;
                _this.formData.title = rowData.title;
                _this.formData.tztgUuid = rowData.tztgUuid;
                setTimeout(function () {
                    _this.formData.ssqhdm = _this.FUNCTIONS.systemFunction.returnArea(rowData.ssqhdm, _this.options);
                    _this.formData.yhlx = _this.FUNCTIONS.systemFunction.returnArea(rowData.yhlx, _this.roleOptions);
                }, 100)
            } else if (type == 'add') {
                _this.editFlag = false;
                title = '通知公告详情新增';
                _this.formData = {
                    tztgUuid:'',
                    uuid: '',
                    ssqhdm: '',
                    nr: '',
                    title: '',
                    yhlx: '',
                    sfqs: '0'
                };
            }
            _this.showFlag = true;
            _this.showTitle = title;
        },
        saveOrUpdateForm(formName) {
            let _this = this;
            let param = {};
            param = _this.formData;
            param = JSON.parse(JSON.stringify(param))
            param.baseService = 'TGcTztgDetailsServiceImpl';
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.formData.ssqhdm) {
                        let arr = []
                        this.formData.ssqhdm.forEach(item => {
                            arr.push(item[item.length - 1])
                        })
                        param.ssqhdm = arr.join(',')
                    }
                    if (this.formData.yhlx) {
                        let arr = []
                        this.formData.yhlx.forEach(item => {
                            arr.push(item[item.length - 1])
                        })
                        param.yhlx = arr.join(',')
                    }
                    let method = "";
                    if (_this.formData.uuid) {
                        method = _this.GLOBAL.config.handleType.updateAll;
                    } else {
                        method = _this.GLOBAL.config.handleType.addTwo;
                    }
                    _this.saveLoading = true
                    _this.FUNCTIONS.systemFunction.interactiveData(
                        _this,
                        _this.GLOBAL.config.businessFlag.zxUser,
                        method,
                        param,
                        null,
                        resultData => {
                            _this.loading = false
                            _this.saveLoading = false
                            if (resultData) {
                                _this.$message.success('保存成功～')
                                _this.showFlag = false;
                                _this.$props.refresh && _this.$props.refresh('init')
                            } else {
                                _this.$message.warning('获取列表数据失败～')
                            }
                        },
                        () => {
                            _this.saveLoading = false
                            _this.loading = false
                        }
                    )
                } else {
                    return false;
                }
            });
        }
    },

    mounted() {
        this.getAllBotice();
        console.log(JSON.parse(localStorage.getItem('noticeDetailsTree')));
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/notice/NoticeDetailDialog.vue